export default __webpack_public_path__ + "static/media/tag-running.81a15ddc.svg";